import { render, staticRenderFns } from "./InputPlainText.vue?vue&type=template&id=ba3ab404&scoped=true"
import script from "./InputPlainText.vue?vue&type=script&lang=js"
export * from "./InputPlainText.vue?vue&type=script&lang=js"
import style0 from "./InputPlainText.vue?vue&type=style&index=0&id=ba3ab404&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba3ab404",
  null
  
)

export default component.exports